import { call, put, takeLatest } from "redux-saga/effects";
import { httpCreateSectionImage } from "../../../services/section";
import {
  editSectionMediaFailure,
  editSectionMediaStart,
  editSectionMediaSuccess,
  editSectionStart,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpPostAudioFile } from "../../../services/audio";
import { createAudioFailure, createAudioSuccess } from "../../audio/reducer";

export function* handleEditMedia({ payload }) {
  const { data, callback } = payload;

  let imageFile = data?.imageUrl;
  let audioObj = data.multimediaFile;
  let multimediaFileId;
  let imageUrl = data?.imageUrl;

  if (audioObj.file !== null && audioObj.upload) {
    const responseAudio = yield call(httpPostAudioFile, audioObj.file);
    const { success, raw, message } = responseAudio;
    if (success) {
      multimediaFileId = raw?.id;
      yield put(createAudioSuccess());
    } else {
      yield put(createAudioFailure());
      networkErrorHandler(responseAudio.statusCode, message || raw?.error);
      return;
    }
  }

  if (imageFile && typeof imageFile !== "string") {
    const response = yield call(httpCreateSectionImage, imageFile);
    const { success, raw, message } = response;
    if (success) {
      imageUrl = raw.id;
      yield put(editSectionMediaSuccess());
    } else {
      yield put(editSectionMediaFailure());
      networkErrorHandler(response.statusCode, message || raw?.error);
      return;
    }
  }

  let modData = { ...data, imageUrl, multimediaFileId };
  yield put(editSectionStart({ data: modData, callback }));
}

export default function* onEditSectionMedia() {
  yield takeLatest(editSectionMediaStart.type, handleEditMedia);
}
